import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ChipGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  & > span {
    margin: ${({ theme }) => theme.deprecatedSpacing.component.one};
  }
`;

const StyledChip = styled.span<{ color?: ChipColors }>`
  display: inline-block;
  border-radius: ${({ theme }) => theme.deprecatedBorder.radius.normal};
  padding: ${({ theme }) => theme.deprecatedSpacing.component.four};

  background-color: ${({ theme, color }) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    return color ? theme.deprecatedColors.accent[color] : theme.deprecatedColors.accent.five;
  }};
  color: ${({ theme }) => theme.deprecatedColors.white};

  .delete-icon {
    &:hover {
      cursor: pointer;
    }
  }
`;

export enum ChipColors {
  one = "one",
  two = "two",
  three = "three",
  four = "four",
  five = "five",
  six = "six",
  seven = "seven",
  eight = "eight",
  nine = "nine",
}

interface ChipProps {
  label: string;
  onDelete?: (value: string) => void;
  color?: ChipColors;
}

export default function Chip({ label, onDelete, color = ChipColors.six }: ChipProps) {
  return (
    <StyledChip color={color}>
      {label}{" "}
      {onDelete && (
        <FontAwesomeIcon
          size="sm"
          icon="times"
          onClick={() => onDelete(label)}
          className="delete-icon"
        />
      )}
    </StyledChip>
  );
}
